export default __webpack_public_path__ + "static/media/whatsapp-logo.1d1b7a80.svg";